/* Common */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

/* Modules */
import { AlertModule } from '../alerts/store/alert.module';
import { CoreModule } from '../shared/core.module';
import {
    QuotientNgCoreModule,
    NavigationModule,
    FiltersModule,
    SharedModule,
    LayoutsModule
} from 'quotient-ng-core';

/* Components */
import { LayoutSecureComponent } from './layout-secure/layout-secure.component';
import { LayoutPublicComponent } from './layout-public/layout-public.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderBareComponent } from './header/header-bare/header-bare.component';
import { HeaderFullComponent } from './header/header-full/header-full.component';
import { SubNavbarComponent } from './sub-navbar/sub-navbar.component';

@NgModule({
    declarations: [
        LayoutSecureComponent,
        LayoutPublicComponent,
        FooterComponent,
        HeaderBareComponent,
        HeaderFullComponent,
        SubNavbarComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        CoreModule,
        AlertModule,
        QuotientNgCoreModule,
        NavigationModule,
        FiltersModule,
        SharedModule,
        LayoutsModule
    ],
    exports: [
        LayoutSecureComponent,
        LayoutPublicComponent,
        HeaderFullComponent,
        FooterComponent,
        HeaderBareComponent,
        SubNavbarComponent
    ]
})
export class LayoutModule {}
